const PARTNERS = [
  { name: "Valetax", url: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/ipk781e4_Valetax%20Logo_Sec.PNG" },
  { name: "Bullfy", url: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/inirjxor_BULLFY_LOGO%5B1%5D.png" },
  { name: "EBC Financial Group", url: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/0nzxgcfv_logo%202026%20EBC-02.png" },
  { name: "Spice Prop", url: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/i6jd85yy_spicebar_logo_white.png" },
  { name: "Hotmart", url: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/nfg15hbf_hotmart_blanco_hd.png" },
  { name: "IMB Capital Quants", url: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/wyatxqcv_IMB_logo_recreated_white.png" },
  { name: "Sinapsis", url: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/df786gb1_SINAPSIS_LOGO_WHITE.png", scale: 2.4 },
];

export default function Partners() {
  const Row = () => (
    <div className="flex shrink-0 items-center gap-16 pr-16">
      {PARTNERS.map((p) => (
        <img
          key={p.name}
          src={p.url}
          alt={p.name}
          style={p.scale ? { transform: `scale(${p.scale})` } : undefined}
          className="h-14 md:h-16 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity"
          loading="lazy"
        />
      ))}
    </div>
  );

  return (
    <section className="relative py-16 md:py-20 bg-black border-y border-[#3E4D36]/30" data-testid="partners-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-10 text-center">
        <span className="text-xs font-display uppercase tracking-[0.4em] text-white/50">
          / Brokers & Partners Aliados
        </span>
      </div>

      <div className="flex overflow-hidden">
        <div className="flex animate-marquee-fast">
          <Row />
          <Row />
          <Row />
        </div>
      </div>
    </section>
  );
}
